import css from 'styled-jsx/css';

const styles = css.global`#bens-servicos-pf-confira-passo-a-passo .ctn-home-24 {
    display: flex;
    flex-direction: column-reverse;
}

@media (min-width: 992px) {
    #perguntas .perguntas-contain{
    margin-top: 112px;
    margin-bottom: 24px;
    }
}`;

export default styles;